const types = {
    VENUES_REQUEST: 'venues/VENUES_REQUEST',
    VENUES_REQUEST_COMPLETED: 'venues/VENUES_REQUEST_COMPLETED',
};

export default {
    ...types,
};
